import './items';

export const filtersStore = {
    namespaced: true,
    state() {
        return {
            search: '',
            filterItems: [],
            rubric_id: [],
            education_subject_id: [],
            type_id: [],
            direction_id: [],
            owner_team_id: [],
            education_grade: [],
            published_at: [], // updated_at
        }
    },
    actions: {
        async getFilters(store) {
            let classData = [];

            for (let i = 1; i < 12; i++) { // выведет 0, затем 1, затем 2
                classData.push({
                    id: i,
                    label: i,
                })
            }

            // Получаем рубрики
            store.commit('getData', {
                url: 'https://navigator.apkpro.ru/api/rubrics/',
                slug: 'rubrics',
                label: 'Рубрика',
                multiple: true,
                name: 'rubric_id'
            });

            // Получаем Тип
            store.commit('getData', {
                url: 'https://navigator.apkpro.ru/api/types/',
                slug: 'types',
                label: 'Вид',
                multiple: true,
                name: 'type_id',
            });

            // Получаем Направление деятельности
            // store.commit('getData', {
            //     url: 'https://navigator.apkpro.ru/api/directions/',
            //     slug: 'directions',
            //     name: 'direction_id',
            //     label: 'Направление деятельности',
            // });

            // Класс
            // store.commit('getData', {
            //     url: 'https://navigator.apkpro.ru/api/education_grade/',
            //     slug: 'education_grade',
            //     name: 'education_grade',
            //     label: 'Класс',
            // });

            // Предмет
            store.commit('getData', {
                url: 'https://navigator.apkpro.ru/api/education_subjects/',
                slug: 'education_subject',
                name: 'education_subject_id',
                multiple: true,
                label: 'Предмет',
            });

            // Разработчики
            store.commit('getData', {
                url: 'https://navigator.apkpro.ru/api/teams/',
                slug: 'owner_team',
                name: 'owner_team_id',
                multiple: true,
                label: 'Разработчики',
            });

            // Добавим классы
            store.commit('setCustomFilter', {
                slug: 'education_grade',
                name: 'education_grade',
                multiple: false,
                label: 'Класс',
                data: classData,
            });
        },
        sendFilters({ dispatch }) {
            dispatch('itemsStore/sendFilters', '', { root: true })
        },
        resetFilter({ commit, dispatch }){
            commit('setDefaultData');
            dispatch('itemsStore/sendFilters', '', { root: true })
        },
    },
    mutations: {
        getData: (state, payload = {}) => {
            fetch(payload.url)
                .then(response => response.json())
                .then((data)  => {
                    state.filterItems.push({
                        slug: payload.slug,
                        label: payload.label,
                        name: payload.name,
                        multiple: payload.multiple,
                        options: data
                    });
                });
        },
        setCustomFilter: (state, payload = {}) => {
            state.filterItems.push({
                slug: payload.slug,
                label: payload.label,
                name: payload.name,
                multiple: payload.multiple,
                options: payload.data
            })
        },
        setElement: (state, payload = {}) => {
            state[payload.name] = [payload.value];
        },
        setDate: (state, payload = {}) => {
            console.log('setDate')
            console.log(payload)
            if(payload.value.from !== '' && payload.value.to !== '') {
                state.published_at['from'] = payload.value.from;
                state.published_at['to'] = payload.value.to;
            } else {
                state.published_at = [];
            }
        },
        setDefaultData: (state, payload) => {
            state.search = '';
            state.rubric_id = [];
            state.type_id = [];
            state.direction_id = [];
            state.owner_team_id = [];
            state.education_subject_id = [];
            state.education_grade = [];
            state.published_at = [];
        }
    }
}